import styled from 'react-emotion';

const FieldLabel = styled.div`
  color: ${p => p.theme.gray5};
`;

export default FieldLabel;



// WEBPACK FOOTER //
// ./app/views/settings/components/forms/field/fieldLabel.jsx